export default __webpack_public_path__ + "096c7b9955e39c9a19e6a3b705e2dc8d.png";